import React from 'react'
import PropTypes from 'prop-types'
import { Card, Affix, Button, message } from 'antd'
import { get } from 'lodash'
import CustomTransfer from 'App/Screens/SubModules/UserGroup/User/Management/Component/CustomTransfer'
import { RequestV2 as Request } from 'App/Utils'

class PageReports extends React.PureComponent {
  constructor(props) {
    super(props)

    this.reportTitles = ['Available Allowed Reports', 'Chosen Allowed Reports']
    this.state = {
      isSaving: false,
    }
  }

  onSave = () => {
    if (get(this._report, 'validateFields')) {
      const userAllowedReports = this._report.validateFields()
      this.setState({ isSaving: true }, () => {
        Request(
          'patch',
          'module-groupUser-user-update',
          {},
          { user_allowed_reports: userAllowedReports },
          [get(this.props.user, 'pk')],
          this.saveSuccess,
          this.saveFailed,
        )
      }) 
    }
  }

  saveSuccess = () => {
    message.success('Access "Reports" has been saved')
    this.setState({ isSaving: false })
  }

  saveFailed = () => {
    message.error('Failed to save Reports')
    this.setState({ isSaving: false })
  }

  render() {
    const { userHelper, user } = this.props
    const { isSaving } = this.state

    return (
      <div>
        <div style={{ borderLeft: '3px solid #1890ff', backgroundColor: '#d9ecfd', padding: '8px' }}>
          Don't forget to save your changes. Because data changes will be lost when moving pages.
          Tab active: <b>REPORTS</b>
        </div>
        <Card>
          <div style={{ padding: '12px 24px' }}>
            <CustomTransfer
              ref={ref => {this._report = ref}}
              titles={this.reportTitles}
              dataSource={userHelper.report}
              initialValue={user.user_allowed_reports}
              // setTouched={}
            />
          </div>
          <Affix offsetBottom={0}>
            <div style={{ backgroundColor: '#fff', padding: '12px 0px' }}>
              <Button block type='primary' loading={isSaving} onClick={this.onSave}>
                Save
              </Button>
            </div>
          </Affix>
        </Card>
      </div>
    )
  }
}

export default PageReports